var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-expansion" }, [
    _c(
      "div",
      { staticClass: "viq-expansion__header" },
      [
        _c("h3", { staticClass: "viq-expansion__title" }, [
          _vm._v("Expansion Opportunity"),
        ]),
        _vm._v(" "),
        _vm.step === "form"
          ? _c(
              "el-button",
              { attrs: { size: "small" }, on: { click: _vm.goBack } },
              [_vm._v("Back")]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.step === "form"
      ? _c("div", { staticClass: "viq-expansion__form" }, [
          _c("p", { staticClass: "viq-expansion__desc" }, [
            _vm._v(
              "\n      Evaluate expansion opportunities with market readiness heatmaps, regulatory paths, and risk rankings.\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "viq-expansion__field" },
            [
              _c("label", [_vm._v("Current Operating Jurisdictions")]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { placeholder: "e.g., United Kingdom, Germany" },
                model: {
                  value: _vm.currentMarkets,
                  callback: function ($$v) {
                    _vm.currentMarkets = $$v
                  },
                  expression: "currentMarkets",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "viq-expansion__field" },
            [
              _c("label", [_vm._v("Target Markets (optional)")]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { placeholder: "e.g., France, Netherlands, Singapore" },
                model: {
                  value: _vm.targetMarkets,
                  callback: function ($$v) {
                    _vm.targetMarkets = $$v
                  },
                  expression: "targetMarkets",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "viq-expansion__field" },
            [
              _c("label", [_vm._v("Business Type / Product")]),
              _vm._v(" "),
              _c("el-input", {
                attrs: { placeholder: "e.g., Cross-border payment services" },
                model: {
                  value: _vm.businessType,
                  callback: function ($$v) {
                    _vm.businessType = $$v
                  },
                  expression: "businessType",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "viq-expansion__form-actions" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: !_vm.currentMarkets.trim(),
                    loading: _vm.loadingBaseline,
                  },
                  on: { click: _vm.fetchBaseline },
                },
                [_vm._v("\n        Analyse Opportunities\n      ")]
              ),
            ],
            1
          ),
        ])
      : _c("div", { staticClass: "viq-expansion__results" }, [
          _vm.expansionBaseline
            ? _c("div", { staticClass: "viq-expansion__baseline" }, [
                _c("h4", [_vm._v("Baseline Assessment")]),
                _vm._v(" "),
                _vm.expansionBaseline.markets
                  ? _c(
                      "div",
                      { staticClass: "viq-expansion__heatmap" },
                      _vm._l(
                        _vm.expansionBaseline.markets,
                        function (market, i) {
                          return _c(
                            "div",
                            { key: i, staticClass: "viq-expansion__market" },
                            [
                              _c(
                                "span",
                                { staticClass: "viq-expansion__market-name" },
                                [_vm._v(_vm._s(market.name))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "viq-expansion__market-score",
                                  class: _vm.scoreClass(market.readiness_score),
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(market.readiness_score || "N/A") +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "viq-expansion__market-label" },
                                [_vm._v(_vm._s(market.readiness_label || ""))]
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isStreaming || _vm.streamingText
            ? _c("div", { staticClass: "viq-expansion__stream" }, [
                _vm.isStreaming
                  ? _c("div", { staticClass: "viq-expansion__streaming" }, [
                      _c("span", { staticClass: "viq-expansion__spinner" }),
                      _vm._v(
                        "\n        Generating detailed analysis...\n      "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.streamingText || _vm.reportContent
                  ? _c("div", {
                      staticClass: "viq-expansion__content",
                      domProps: { innerHTML: _vm._s(_vm.renderedContent) },
                    })
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isStreaming && (_vm.expansionBaseline || _vm.reportContent)
            ? _c(
                "div",
                { staticClass: "viq-expansion__actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("export-pdf")
                        },
                      },
                    },
                    [_vm._v("Export as PDF")]
                  ),
                  _vm._v(" "),
                  _vm.$config.features && _vm.$config.features.viqShare
                    ? _c("el-button", { on: { click: _vm.share } }, [
                        _vm._v("Save & Share"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.reset } }, [
                    _vm._v("New Analysis"),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }